import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { CoverageEntry } from '@Types/riskCoverage.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const coverageSelector = createSelector(
	parseNamespace,
	state => state.RiskStore.coverage,
);

export const selectCoverageStatus = createSelector(
	coverageSelector,
	state => state.status,
);

export const selectCoverageEntries = createSelector(
	coverageSelector,
	state => state.entries,
);

export const selectCoverageForComponent = createSelector(
	[
		coverageSelector,
		(_state: NamespacedStoreState, categoryName: string) => categoryName,
		(_state: NamespacedStoreState, _categoryName: string, name: string) =>
			name,
	],
	(coverage, categoryName, name): CoverageEntry | undefined =>
		coverage.entries.find(
			e => e.categoryName === categoryName && e.name === name,
		),
);
